import { useField } from 'formik';
import { TimeSearchSelect, TimeSearchSelectProps } from './TimeSeachSelect';
import { TimeSelect, TimeSelectProps } from './TimeSelect';
import { CalendarDateService } from '@uplift/services';
import { TIME_RANGE_DATE_VALUE_FORMAT } from './constants';

export const getStartAndEndTimeInput = (fromDatetime: string, tz: string, start: string, end: string) => { // string format HH:mm:ss
  const baseDate = CalendarDateService.date(fromDatetime).tz(tz).startOf('D');
  const startDate = CalendarDateService.date(start, TIME_RANGE_DATE_VALUE_FORMAT);
  const endDate = CalendarDateService.date(end, TIME_RANGE_DATE_VALUE_FORMAT);

  const startTime = baseDate.set('hour', startDate.hour()).set('minute', startDate.minute());
  const endTime = baseDate.set('hour', endDate.hour()).set('minute', endDate.minute());

  return { startTime: startTime.toISOString(), endTime: endTime.toISOString() };
};

export type TimePickerProps = {
  searchSelect?: boolean;
} & (
  | TimeSelectProps
  | TimeSearchSelectProps
);

export const TimePickerRaw: React.VFC<TimePickerProps> = ({ searchSelect, ...props }) => {
  const FieldInput = searchSelect
    ? TimeSearchSelect
    : TimeSelect;

  return <FieldInput {...props} />;
};


export const TimePicker: React.VFC<Omit<TimePickerProps, 'value' | 'setValue'>> = (props) => {
  const [ field, _meta, helpers ] = useField(props.name);

  return (
    <TimePickerRaw {...props} value={field.value} setValue={helpers.setValue} />
  );
};
